export enum OrganiserType {
  EC_REPRESENTATION_OR_DELEGATION = 'EC_REPRESENTATION_OR_DELEGATION',
  EU_INSTITUTIONS_EC_PARLIAMENT_EESC_COR = 'EU_INSTITUTIONS_EC_PARLIAMENT_EESC_COR',
  EEU_LEVEL_BUSINESS_ORGANISATION = 'EEU_LEVEL_BUSINESS_ORGANISATION',
  EU_LEVEL_YOUTH_BUSINESS_ORGANISATION = 'EU_LEVEL_YOUTH_BUSINESS_ORGANISATION',
  EUROPE_DIRECT = 'EUROPE_DIRECT',
  NATIONAL_OR_REGIONAL_OFFICE_IN_BRUSSELS = 'NATIONAL_OR_REGIONAL_OFFICE_IN_BRUSSELS',
  CHAMBERS_OF_COMMERCE_AND_INDUSTRY_OR_CHAMBER_OF_ECONOMY = 'CHAMBERS_OF_COMMERCE_AND_INDUSTRY_OR_CHAMBER_OF_ECONOMY',
  CHAMBERS_OF_SKILLED_CRAFTS = 'CHAMBERS_OF_SKILLED_CRAFTS',
  EDUCATION_INSTITUTIONS_UNIVERSITIES_OR_SCHOOLS = 'EDUCATION_INSTITUTIONS_UNIVERSITIES_OR_SCHOOLS',
  ENTERPRISE_ASSOCIATION = 'ENTERPRISE_ASSOCIATION',
  ENTERPRISES = 'ENTERPRISES',
  INCUBATORS = 'INCUBATORS',
  INNOVATION_CENTRES = 'INNOVATION_CENTRES',
  LOCAL_DEVELOPMENT_AGENCY_FOR_SMES = 'LOCAL_DEVELOPMENT_AGENCY_FOR_SMES',
  MINISTRIES = 'MINISTRIES',
  NATIONAL_BUSINESS_ORGANISATION_OR_ASSOCIATION = 'NATIONAL_BUSINESS_ORGANISATION_OR_ASSOCIATION',
  NATIONAL_DEVELOPMENT_AGENCY_FOR_SMES = 'NATIONAL_DEVELOPMENT_AGENCY_FOR_SMES',
  NATIONAL_YOUTH_BUSINESS_ORGANISATION_OR_ASSOCIATION = 'NATIONAL_YOUTH_BUSINESS_ORGANISATION_OR_ASSOCIATION',
  REGIONAL_LOCAL_PUBLIC_AUTHORITIES = 'REGIONAL_LOCAL_PUBLIC_AUTHORITIES',
  SME_DEVELOPMENT_ORGANIZATION_PUBLIC_OR_PRIVATE = 'SME_DEVELOPMENT_ORGANIZATION_PUBLIC_OR_PRIVATE',
  OTHER = 'OTHER',
}
